import React, { memo } from 'react';
import { Wrapper, Icon, Title, TitleBlock, ValueBlock } from './styled';
import Value from '../Value';
import { icons } from '../icons';

const Index = ({
    headingColor,
    title,
    value,
    valueText,
    valueAction,
    valueActionPeriod,
    typeValue,
    onClickValue,
    typeOptions,
    labelLeft,
    horizontally,
    descriptionValue = ''
}) => (
    <Wrapper horizontally={horizontally}>
        <TitleBlock title={title} horizontally={horizontally}>
            <Icon headingColor={headingColor}>
                {icons[typeOptions]()}
            </Icon>
            <Title horizontally={horizontally}>
                {title}
                {
                    horizontally &&
                    <Value
                        headingColor={headingColor}
                        value={value}
                        valueText={valueText}
                        valueAction={valueAction}
                        valueActionPeriod={valueActionPeriod}
                        type={typeValue}
                        onClick={onClickValue}
                        labelBottom={horizontally}
                        labelLeft={labelLeft}
                        description={descriptionValue}
                    />
                }
            </Title>
        </TitleBlock>
        { !horizontally &&
        <ValueBlock>
            <Value
                headingColor={headingColor}
                value={value}
                valueText={valueText}
                valueAction={valueAction}
                valueActionPeriod={valueActionPeriod}
                type={typeValue}
                onClick={onClickValue}
                labelLeft={labelLeft}
                description={descriptionValue}
            />
        </ValueBlock>
        }
    </Wrapper>
);

export default memo(Index);
